<template>
  <div>{{ticketCount}}</div>
</template>

<script>
export default {
  name: "TicketCountByTag",

  props : ['tag'],

  data() {
    return {
        ticketCount : 0
    }
  },

  mounted() {
      var _this = this;
      sdk.TicketApi().countByFilter({
          filter : { $ticket_tag_by : _this.tag }
      }).then(res => {
          _this.ticketCount = res;
      });
  }
}
</script>


// WEBPACK FOOTER //
// src/components/setting/TicketCountByTag.vue